import * as React from "react";
import "./badgeChainList.css";
import "../../style/fonts.css";
import BadgeChain from "./badgeChain";

export interface Props {
  badgeChain: any;
}

class BadgeChainList extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    if (this.props.badgeChain) {
      const myList = this.props.badgeChain;
      const badges = Object.keys(myList).map((cat, index) => {
        return (
          <BadgeChain key={index} category={cat} state={myList[cat].state} />
        );
      });
      return badges;
    } else return null;
  }
}

export default BadgeChainList;



// WEBPACK FOOTER //
// ./src/components/badges/badgeChainList.tsx